import { Image } from "@wss/image";
import React from "react";
import { cls } from "cls";
import { useHomePageData } from "../utilities";
const RestaurantBrands = () => {
  const {
    restaurantBrands
  } = useHomePageData();
  return <div className="container bg-white" data-sentry-component="RestaurantBrands" data-sentry-source-file="index.tsx">
      <div className="mx-auto" data-testid="shop-popular-brands">
        <h2 className="text-center text-gray-800 text-2xl md:text-3xl mb-4" style={{
        lineHeight: "0.75"
      }}>
          Shop Popular Brands
        </h2>
        <div className={cls("flex flex-wrap float-none justify-center w-full", "xl:flex-no-wrap xl:justify-between")}>
          {restaurantBrands.map(b => <a className={cls("flex justify-center items-center w-1/5 m-1 bg-gray-50 p-4 rounded hover:opacity-75 transition-all duration-75 ease-in-out", "sm:m-1.5 sm:w-1/4", "md:m-1 md:box-border", "lt:m-1.5", "xl:m-0 xl:mb-4 xl:w-32")} href={b.link} title={b.name} data-testid="brand-item" key={b.name}>
              <Image src={b.brandLogo} alt={b.name} loading="lazy" width={200} height={109} className={cls("h-12 object-contain max-w-full", "sm:h-16", "lz:w-32 lz:h-20", "xxl:h-16")} style={{
            mixBlendMode: "darken"
          }} />
            </a>)}
        </div>
      </div>
    </div>;
};
export default RestaurantBrands;